class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.attachCartChangeListeners();
    this.giftMap = {};
  }

  //Custm dev code to manage gift card item start

//  async syncGiftProduct() {
 
//   // document.querySelectorAll('[data-parent-variant-id]').forEach(async (cartItemEl) => {
//   // const parentProductId = parseInt(cartItemEl.dataset.parentVariantId, 10);
//   // const giftProductId = parseInt(cartItemEl.dataset.giftVariantId, 10);

//   // if (!parentProductId || !giftProductId){
//   //    return;
//   // }
 
  
//   const parentProductId = 44566219784329; //  Replace with actual parent VARIANT ID
//   const giftProductId = 44561362878601;   //  Replace with actual gift VARIANT ID
 
//   const minParentQty = 2;
//   const giftQty = 1;

//   const sections = ['cart-drawer', 'cart-icon-bubble'];
//   const sectionsUrl = window.location.pathname;

//   const cartRes = await fetch('/cart.js');
//   const cart = await cartRes.json();

//   const parentItem = cart.items.find(item => item.variant_id === parentProductId);
//   const giftItemIndex = cart.items.findIndex(item => item.variant_id === giftProductId);

//   const parentQty = parentItem ? parentItem.quantity : 0; 
//   //  ADD gift
//   if (parentQty >= minParentQty && giftItemIndex === -1) {   
//     await fetch('/cart/add.js?sds', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         id: giftProductId,
//         quantity: giftQty,
//         properties: {
//             _auto_gift_for_variant: parentProductId
//           }      
//       })
//     });
//     await this.refreshCartDrawer();
//     return;
//   }

//   //  REMOVE gift
//   if (parentQty < minParentQty && giftItemIndex !== -1) {
//     const line = giftItemIndex + 1; // line is 1-based

//     if (line <= cart.items.length) {      
//       await fetch('/cart/change.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           line: line,
//           quantity: 0,
//           sections,
//           sections_url: sectionsUrl
//         })
//       });
//       await this.refreshCartDrawer();
//     }
//   }
  
//  // });
// }

async syncGiftProduct() {
  const minParentQty = 2;
  const giftQty = 1;

  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();

  // Reset giftMap
  //this.giftMap = {};
  this.giftMap = {
  44566219784329: 44561362878601, // parentVariantId: giftVariantId
  // Add more if needed
};

  // Build the mapping from DOM
  document.querySelectorAll('[data-parent-variant-id]').forEach((el) => {
    const parentId = parseInt(el.dataset.parentVariantId, 10);
    const giftId = parseInt(el.dataset.giftVariantId, 10);
    if (parentId && giftId) {
      this.giftMap[parentId] = giftId;
    }
  });

  let shouldRefreshDrawer = false;

  for (const [parentIdStr, giftId] of Object.entries(this.giftMap)) {
    const parentId = parseInt(parentIdStr, 10);

    const parentItem = cart.items.find(item => item.variant_id === parentId);
    const parentQty = parentItem ? parentItem.quantity : 0;

    const giftItem = cart.items.find(item =>
      item.variant_id === giftId &&
      item.properties &&
      item.properties._auto_gift_for_variant == parentId
    );

    const giftItemIndex = giftItem ? cart.items.indexOf(giftItem) : -1;

    //  ADD GIFT
    if (parentQty >= minParentQty) {
      if (!giftItem) {
        
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftId,
            quantity: giftQty,
            properties: {
              _auto_gift_for_variant: parentId
            }
          })
        });
        shouldRefreshDrawer = true;
      } else if (giftItem.quantity > giftQty) {
        
        // Cap quantity to 1 if it exceeds
        const line = giftItemIndex + 1;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            line,
            quantity: giftQty
          })
        });
        shouldRefreshDrawer = true;
      }
    }

    // REMOVE GIFT
    if (parentQty < minParentQty && giftItemIndex !== -1) {
      
      const line = giftItemIndex + 1;
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line,
          quantity: 0
        })
      });
      shouldRefreshDrawer = true;
    }
  }

   if (shouldRefreshDrawer) {
    await this.refreshCartDrawer();
  }
}


isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}


  async refreshCartDrawer() {
  const sections = this.getSectionsToRender().map(section => section.section || section.id);
  const res = await fetch(`/cart?sections=${sections.join(',')}`);
  const html = await res.json();

  this.renderContents({
    id: 'cart',
    sections: html
  });
}
attachCartChangeListeners() {
  var giftSyncTimeout;

  // Listen for clicks on plus/minus/remove buttons
  // this.addEventListener('click', (event) => {
  //   const target = event.target.closest('button');
  //   if (!target) return;

  //   const isQtyButton = target.name === 'minus' || target.name === 'plus';
  //   const isRemoveButton = target.classList.contains('cart-remove-button') || target.closest('cart-remove-button');

  //   if (isQtyButton || isRemoveButton) {
  //     clearTimeout(giftSyncTimeout);
  //     giftSyncTimeout = setTimeout(() => {
  //       this.syncGiftProduct();
  //     }, 500);
  //   }
  // });

  // // Listen for direct changes in quantity input fields
  // this.addEventListener('change', (event) => {
  //   const input = event.target;
  //   if (input && input.matches('input[type="number"][name="quantity"]')) {
  //     clearTimeout(giftSyncTimeout);
  //     giftSyncTimeout = setTimeout(() => {
  //       this.syncGiftProduct();
  //     }, 500);
  //   }
  // });

  // MutationObserver to detect cart content changes (optional fallback)
  const cartDrawerNode = this.querySelector('#CartDrawer');
  if (cartDrawerNode) {
    const observer = new MutationObserver(() => {
      clearTimeout(giftSyncTimeout);
      giftSyncTimeout = setTimeout(() => {
        //this.syncGiftProduct();
      }, 500);
    });

    observer.observe(cartDrawerNode, {
      childList: true,
      subtree: true,
    });
  }
}


//Custm dev code to manage gift card item end

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }



//    renderContents(parsedState) {
//     this.querySelector('.drawer__inner').classList.contains('is-empty') &&
//       this.querySelector('.drawer__inner').classList.remove('is-empty');
//     this.productId = parsedState.id;
//     this.getSectionsToRender().forEach((section) => {
//       const sectionElement = section.selector
//         ? document.querySelector(section.selector)
//         : document.getElementById(section.id);

//       if (!sectionElement) return;
//       sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
//     });
// console.log("runss")
//     setTimeout(() => {
//       this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
//       this.open();
//     });
   
//   }

 renderContents(parsedState) {
  const drawerInner = this.querySelector('.drawer__inner');
  const emptyClass = 'is-empty';

  // Check if cart is empty
  const isCartEmpty = parsedState.sections['cart-drawer'].includes('cart__empty');

  // Toggle .is-empty class on drawer
  if (isCartEmpty) {
    this.classList.add(emptyClass);
  } else {
    this.classList.remove(emptyClass);
  }

  this.getSectionsToRender().forEach((section) => {
    const sectionElement = section.selector
      ? document.querySelector(section.selector)
      : document.getElementById(section.id);

    if (!sectionElement) return;

    const html = parsedState.sections[section.id];
    const innerHTML = this.getSectionInnerHTML(html, section.selector);
    sectionElement.innerHTML = innerHTML;
  });

  // Reset cart overlay and focus
  setTimeout(() => {
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.open();
  });
 // this.syncGiftProduct();
}


  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
